import { ChangeEventHandler, KeyboardEventHandler, ReactNode } from "react";
import "./LeafToggleSwitch.scss";

export const LeafToggleSwitch = ({
  isToggled,
  onToggle,
  name,
  label,
  toggleOnIcon,
  toggleOffIcon,
  disabled = false,
}: {
  isToggled: boolean;
  onToggle: ChangeEventHandler<HTMLInputElement>;
  name: string;
  label?: string;
  toggleOnIcon?: ReactNode;
  toggleOffIcon?: ReactNode;
  disabled?: boolean;
}) => {
  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.currentTarget.click();
    }
  };

  return (
    <div className={`leafToggleSwitch${disabled ? " leafToggleSwitch--disabled" : ""}`}>
      {label && <span className="leafToggleSwitch__label">{label}</span>}

      <label className="leafToggleSwitch__switch">
        <input
          aria-label={name}
          type="checkbox"
          checked={isToggled}
          onChange={onToggle}
          name={name}
          role="switch"
          disabled={disabled}
          onKeyDown={handleKeyDown}
        />

        <span className="leafToggleSwitch__switchKnob">
          <span className="leafToggleSwitch__knobCircle">
            {isToggled ? (toggleOnIcon ?? null) : (toggleOffIcon ?? null)}
          </span>
        </span>
      </label>
    </div>
  );
};
